

<!-- SOLR - Search bar -->

<div class="input-group">
  <input
    #searchInput 
    id="typeahead-basic" 
    type="search" 
    class="form-control"

    (selectItem)="onSelectedItem($event)"

    [(ngModel)]="selectedItem"
  
    [ngbTypeahead]="search" 

    [placeholder]="placeholder_"
    [ngbTooltip]="ngbTooltip_" 
    [placement]="placement_" 

    [resultFormatter]="resultFormatter_"
    [inputFormatter]="inputFormatter_"
  
  /> 
  <div *ngIf="btnSearch" class="input-group-append pointer" (click)="onSearchItemClick(searchInput)">
    <span class="input-group-text " id="search">
      <fa-icon aria-hidden="true" [icon]="icons.faSearch"></fa-icon>
    </span>
  </div>
</div>